import './ETFFaq.sass';
import { useEffect, useState } from 'react';
import Hero from '../components/Hero';
import Breadcrumbs from '../components/Breadcrumbs';
import Meta from '../components/Meta';
import { useArticles } from '../api';
import ETFFaqCategory from './ETFFaqCategory';

const ETFFaq = (props) => {
	const { routeData } = props;
	const { breadcrumbs } = useArticles(routeData.guid, routeData.route);
	const [currentTab, setCurrentTab] = useState({});

	useEffect(() => {
		setCurrentTab(routeData.categoryChild?.[0]);
	}, [routeData.categoryChild]);

	return (
		<div id='ETFFaq'>
			<Meta data={routeData} />
			<Hero data={breadcrumbs} />
			<Breadcrumbs data={breadcrumbs} />

			<div className='common-pad-wrap'>
				<div className='extra-pad'>
					<div className='tabs'>
						{routeData.categoryChild.map((category) => {
							const { guid, name } = category;

							return (
								<div
									key={guid}
									className={`tab ${currentTab.guid === guid && 'active'}`}
									onClick={() => {
										setCurrentTab(category);
									}}>
									<div className='text'>{name}</div>
								</div>
							);
						})}
					</div>

					<div className='tab-contents'>{currentTab && currentTab.guid ? <ETFFaqCategory data={currentTab} /> : null}</div>
				</div>
			</div>
		</div>
	);
};

export default ETFFaq;
